<template>
    <div class="image container d-flex align-items-center justify-content-center">
        <div class="image-content d-flex flex-column justify-content-center">
            <!-- Close -->
            <div class="close-button cursor-pointer d-flex justify-content-end">
                <p @click="closePopUp"><img src="../assets/close.svg" alt="image" class="w-100"/></p>
            </div>
            <!-- file -->
            <vueper-slides ref="fullscreenGallery" class="no-shadow text-light" :visible-slides="1" :bullets="false" fractions progress :arrowsOutside="true">
                <!-- content -->
                <vueper-slide v-for="(file, index) in gallery" :key="index">
                    <template v-slot:content>
                        <!-- Video content -->
                        <iframe 
                            v-if="file.video" 
                            :src="embedLink(file.video)" 
                            :class="getVideoClass(file.video)"
                            frameborder="0" 
                            allowfullscreen
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                        </iframe>
                        <!-- Image content -->
                        <img v-else :src="file" @error="handleImageError" class="w-100" alt=""/>
                    </template>
                </vueper-slide>
            </vueper-slides>
        </div>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

const ACTIVE = "ActiveBrands";
const INFLATE = "InflateYourImagination";
const FALLBACK_IMAGE_ACTIVE = `${process.env.VUE_APP_URL_ROOT.replace(/\/+$/, "")}/files/product_default.JPG`;
const FALLBACK_IMAGE_INFLATE = `${process.env.VUE_APP_URL_ROOT.replace(/\/+$/, "")}/files/inflate_default.jpg`;

export default {
    components:{VueperSlides, VueperSlide},
    props: {
        gallery: Array,
        startIndex: Number,
        brand: String
    },
    data() {
        return {
            ACTIVE: ACTIVE,
            INFLATE: INFLATE,
            FALLBACK_IMAGE_ACTIVE: FALLBACK_IMAGE_ACTIVE,
            FALLBACK_IMAGE_INFLATE: FALLBACK_IMAGE_INFLATE,
            drag: false
        }
    },
    computed: {
        fallbackImage() {
            return this.brand === this.INFLATE ? this.FALLBACK_IMAGE_INFLATE : this.FALLBACK_IMAGE_ACTIVE;
        }
    },
    mounted: function()
    {
        this.$refs.fullscreenGallery.goToSlide(this.startIndex);
        document.addEventListener('mousedown', () => this.drag = false);
        document.addEventListener('mousemove', () => this.drag = true);
        document.addEventListener('mouseup', this.handleMouseUp);
    },
    destroyed() {
        document.removeEventListener('mousedown', () => this.drag = false);
        document.removeEventListener('mousemove', () => this.drag = true);
        document.removeEventListener('mouseup', this.handleMouseUp);
    },
    methods:
    {
        closePopUp: function()
        {
            this.$emit("closeRequest");
        },
        handleMouseUp(evt) {
            if (!this.drag && evt.target.classList.contains('image')) {
                this.closePopUp();
            }

            this.drag = false;
        },
        handleImageError(event) {
            event.target.src = this.fallbackImage;
        },
        // Convert known video URLs into embeddable iframe src URLs (YouTube, TikTok)
        embedLink: function (link) {
            if (!link || typeof link !== 'string') return link;

            // YouTube: support both watch and youtu.be formats
            try {
                const url = new URL(link);
                const host = url.hostname.replace(/^www\./, '');

                if (host === 'youtube.com' || host === 'm.youtube.com') {
                    const videoId = url.searchParams.get('v');
                    if (videoId) return `https://www.youtube.com/embed/${videoId}`;
                }

                if (host === 'youtu.be') {
                    const videoId = url.pathname.replace(/^\//, '');
                    if (videoId) return `https://www.youtube.com/embed/${videoId}`;
                }

                // TikTok embed: transform URL like /@user/video/VIDEO_ID to /embed/v2/VIDEO_ID
                if (host === 'tiktok.com' || host === 'vm.tiktok.com') {
                    const parts = url.pathname.split('/').filter(Boolean);
                    const videoIndex = parts.findIndex(p => p === 'video');
                    if (videoIndex !== -1 && parts[videoIndex + 1]) {
                        const videoId = parts[videoIndex + 1];
                        return `https://www.tiktok.com/embed/v2/${videoId}`;
                    }
                    // Handle short TikTok URLs
                    if (parts.length === 1 && parts[0]) {
                        return `https://www.tiktok.com/embed/v2/${parts[0]}`;
                    }
                }
            } catch (e) {
                // fall through
            }

            return link;
        },
        // Get CSS class based on video platform
        getVideoClass: function(videoUrl) {
            if (!videoUrl || typeof videoUrl !== 'string') return 'video-iframe';
            
            try {
                const url = new URL(videoUrl);
                const host = url.hostname.replace(/^www\./, '');
                
                if (host === 'tiktok.com' || host === 'vm.tiktok.com') {
                    return 'video-iframe video-tiktok';
                } else if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtu.be') {
                    return 'video-iframe video-youtube';
                }
            } catch (e) {
                // fall through
            }
            
            return 'video-iframe';
        },
    },
    watch:
    {
        startIndex: function()
        {
            this.$refs.fullscreenGallery.goToSlide(this.startIndex);
        }
    }
}
</script>

<style scoped>
.close-button p
{
    position: fixed;
    right: 3%;
    top: 2%;
    width: 35px;
    cursor: pointer;
    font-size: 20px;
    color:white
}
.image{
  position:fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);  
  z-index: 999;
  margin: 0;
  max-width: unset!important;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 5vw;
  padding-bottom: 5vw;
  gap: 16px;
}
.image-content
{
    width: 80%;
    height: 100%;
    min-height: 50%;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
img
{
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
}
.video-iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px;
}
.video-youtube {
    aspect-ratio: 16/9;
}
.video-tiktok {
    aspect-ratio: 9/16;
    max-height: 90vh;
    width: auto;
    margin: 0 auto;
}
::v-deep .vueperslides__progress{
position: unset;
z-index: 0;
height: unset;
color: unset;
}
::v-deep .vueperslides__progress > *{
    position: unset;
    background: unset;
    transition: unset;
}
::v-deep .vueperslides__fractions{
    top: 0%;
    left: unset;
    right: -15%;
    border-radius: unset;
    background: unset;
    border: unset;
    padding: 0;
    font-size: 35px;
}
::v-deep .vueperslides__fractions::first-letter {
  font-size: 150%;
}
::v-deep .vueperslide {
    background-size: contain;
    background-repeat: no-repeat;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
::v-deep .vueperslides{
    height: 100%;
}
::v-deep .vueperslides__inner,
::v-deep .vueperslides__parallax-wrapper{
    height: 100%;
}
@media (max-width: 991px) {
  .image {
    padding-left: 4vw;
    padding-right: 4vw;
    padding-top: 4vw;
    padding-bottom: 4vw;
  }
  .image-content
    {
        height: 75%;
        width: 85%; 
    }
    ::v-deep .vueperslides__fractions {
            top: -85px;
            right: -15px;
        }
    .video-iframe {
        max-height: 100%;
        max-width: 100%;
    }
    .video-youtube {
        aspect-ratio: 16/9;
    }
    .video-tiktok {
        aspect-ratio: 9/16;
        height: 100%;
        max-height: 100%;
        width: auto;
        margin: 0 auto;
    }
}

@media (max-width: 575px) {
    .image {
        padding-left: 3vw;
        padding-right: 3vw;
        padding-top: 3vw;
        padding-bottom: 3vw;
    }
    ::v-deep .vueperslides{
        height: 100%;
        min-height: 140px;
    }
    ::v-deep .vueperslides__arrow--prev,
    ::v-deep .vueperslides__arrow--next{
        font-size: 13px;
    }
    .video-iframe {
        max-height: 100%;
        max-width: 100%;
    }
    .video-youtube {
        aspect-ratio: 16/9;
    }
    .video-tiktok {
        aspect-ratio: 9/16;
        height: 100%;
        max-height: 100%;
        width: auto;
        margin: 0 auto;
    }
    img {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }
}
</style>